import React, { useEffect } from "react";

const DownloadApp = () => {
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      // Google Play Store link
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.yourfriend.myfriend";
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      // Apple App Store link
      window.location.href =
        "https://apps.apple.com/us/app/your-friend-my-friend/id6748553590";
    } else {
      // Agar desktop hai to website dikhao
      window.location.href = "https://yourfriendmyfriend.ie/";
    }
  }, []);

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <h4>Redirecting you to the right store...</h4>
    </div>
  );
};

export default DownloadApp;
